import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_w9Xrf1I9oxmi: {
	id: 'prd_w9Xrf2DEV21I9oxmi'
	ident: 'prd_w9Xrf1I9oxmi'
	sku: 'simple_premium_12w_15_99_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_c3UFB2DEV2c6luzVi'
			amount: 79
			amount_usd: 15.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 15.99
			discount: 63.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_WcTCb2DEV2rPqNhCW'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_w9Xrf1I9oxmi, SubscriptionProduct>
const prd_w9Xrf1I9oxmi = { ident: 'prd_w9Xrf1I9oxmi' } as typeof _prd_w9Xrf1I9oxmi

export default prd_w9Xrf1I9oxmi
